import { shade, tint } from 'polished';

interface RGB {
  red: number;
  green: number;
  blue: number;
}

export class CorUtil {
  static rgb(cor: string): string {
    const rgb = this.getRGB(cor);

    return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue})`;
  }

  static rgba(cor: string, alpha: number): string {
    const rgb = this.getRGB(cor);

    return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${alpha})`;
  }

  static shade(cor: string, porcentagem: number): string {
    return shade(porcentagem, cor);
  }

  static tint(cor: string, porcentagem: number): string {
    return tint(porcentagem, cor);
  }

  private static getRGB(cor: string): RGB {
    let color = cor.toString();

    if (color.indexOf('#') === 0) {
      color = color.slice(1);
    }

    const rgb: RGB = {
      red: parseInt(color.slice(0, 2), 16),
      green: parseInt(color.slice(2, 4), 16),
      blue: parseInt(color.slice(4, 6), 16),
    };

    return rgb;
  }
}
